import React from 'react'
import Slider from 'react-slick';
import './logoslider.css'
import c1 from '..//../img/client-logo/1.jpg'
import c2 from '..//../img/client-logo/2.jpg'
import c3 from '..//../img/client-logo/3.jpg'
import c4 from '..//../img/client-logo/4.jpg'
import c5 from '..//../img/client-logo/5.jpg'
import c6 from '..//../img/client-logo/6.jpg'
import c7 from '..//../img/client-logo/7.jpg'
import c8 from '..//../img/client-logo/8.jpg'
import c9 from '..//../img/client-logo/9.jpg'
import c10 from '..//../img/client-logo/10.jpg'
import c11 from '..//../img/client-logo/11.jpg'
import c12 from '..//../img/client-logo/12.jpg'
import c13 from '..//../img/client-logo/13.jpg'
import c14 from '..//../img/client-logo/14.jpg'
import c15 from '..//../img/client-logo/15.jpg'
import c16 from '..//../img/client-logo/16.jpg'
const LogoSlider = () => {
	var settings = {
		dots: false,
		infinite: true,
		speed: 1000,
		autoplay: true,
		slidesToShow: 6,
		slidesToScroll: 1,
		initialSlide: 0,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true,
					dots: true,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					initialSlide: 2,
				},
			},
			{
				breakpoint: 780,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 580,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 500,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	};
	return (
		<div className="slider-logo-container">
			<div className="container">
				<div className="row">
					<div className="col-lg-12">
						<div className="section-title">
							<h5 className="title-sub">awesome partner</h5>
							<h2 className="title-1">Our Clients</h2>
						</div>
						<Slider {...settings}>
							<div>
								<img src={c1} alt="" />
							</div>
							<div>
								<img src={c2} alt="" />
							</div>
							<div>
								<img src={c3} alt="" />
							</div>
							<div>
								<img src={c4} alt="" />
							</div>
							<div>
								<img src={c5} alt="" />
							</div>
							<div>
								<img src={c6} alt="" />
							</div>
							<div>
								<img src={c7} alt="" />
							</div>
							<div>
								<img src={c8} alt="" />
							</div>
							<div>
								<img src={c9} alt="" />
							</div>
							<div>
								<img src={c10} alt="" />
							</div>
							<div>
								<img src={c11} alt="" />
							</div>
							<div>
								<img src={c12} alt="" />
							</div>
							<div>
								<img src={c13} alt="" />
							</div>
							<div>
								<img src={c14} alt="" />
							</div>
							<div>
								<img src={c15} alt="" />
							</div>
							<div>
								<img src={c16} alt="" />
							</div>
						</Slider>
					</div>
				</div>
			</div>
		</div>
	);
}

export default LogoSlider